<template>
  <div>
    <a-modal
      title=""
      :open="showNoticeModal"
      v-if="showNoticeModal"
      class="small noticeModal"
      width="500px"
      :footer="null"
      @cancel="close"
    >
      <div class="pl-15px inline-block align-top">
        <h5 class="text-16px">
          <NotificationOutlined
            class="pr-10px inline-block align-middle text-18px text-[#1890FF]"
          />
          <span class="inline-block align-middle font-600">{{
            noticeDetailInfo?.title
          }}</span>
        </h5>
        <div class="!px-30px text-12px notice-content mt-10px">
          {{ noticeModalState.content }}
        </div>
      </div>

      <div class="text-right pt-10px">
        <a-button size="small" class="mr-8px" @click="close">知道了</a-button>
        <a-button size="small" type="primary" @click="checkDetail"
          >查看详情</a-button
        >
      </div>
    </a-modal>
  </div>
</template>
<script setup>
// import { inject } from 'vue'
import { useNoticeModal } from '../share'
import { NotificationOutlined } from '@ant-design/icons-vue'

const props = defineProps({
  noticeDetailInfo: {
    type: Object,
    default: () => {}
  },
  visible: {
    type: Boolean,
    default: false
  }
})
// const showNoticeModal = inject('showNoticeModal')
const noticeModalModule = useNoticeModal(props, emit)
const emit = defineEmits(['close', 'openDetail'])
const close = () => {
  emit('close')
}
const openDetail = () => {
  emit('openDetail')
}
const { noticeModalState, checkDetail, showNoticeModal } = noticeModalModule
// provide('noticePublishModule', noticeModalModule)
</script>
<style lang="scss" scoped>
.notice-content img {
  max-height: 100px !important;
}
.notice-content {
  overflow: hidden;
  display: flex;
  align-items: center;
  max-height: 68px;
}
.notice-content {
  padding: 5px 0;
  line-height: 20px;
}
</style>
